var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8h11.865l-3.633 4.36a1 1 0 101.537 1.28l5-6c.039-.047.058-.102.087-.154.024-.042.053-.078.071-.124a.985.985 0 00.072-.358L16.5 7l-.001-.004a.985.985 0 00-.072-.358c-.018-.046-.047-.082-.071-.124-.029-.052-.048-.107-.087-.154l-5-6A1.002 1.002 0 009.86.232a1 1 0 00-.128 1.408L13.365 6H1.5a1 1 0 000 2z",
    fill: "#697484"
  })));
}

export default SvgArrowRightGray;